import { Navigate } from 'react-router-dom';
import { useOrganisation } from '../contexts/OrganisationContext';

const ProtectedE2EReviewerRoute = ({ children }) => {
    const { activeRoleId } = useOrganisation();

    if (!activeRoleId?.toLowerCase().endsWith('-e2e-reviewer')) {
        return <Navigate to="/start" replace />;
    }

    return children;
};

export default ProtectedE2EReviewerRoute;